import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

const LoginForm = () => {
    const { login } = useAuth();
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        const success = login(formData.email, formData.password);
        if (!success) setError('Invalid credentials');
    };

    return (
        <>
        <div className="login-container">
        <div className="login-box">
        <Row className="justify-content-center mt-5">
            <Col md={6}>
                <img src="logo.png" alt="Logo" className='img-fluid img-responsive' />
            </Col>
        </Row>
            <Row className="justify-content-center mt-5">
                <Col md={12}>
                    <Card>
                        <Card.Body className='login_form_wrap'>
                            {/* <h2 className="text-center mb-4">Login</h2> */}
                            {error && <Alert variant="danger">{error}</Alert>}
                            <Form onSubmit={handleSubmit}>
                                <label className='mb-2 login_label'>Enter Email</label>
                                <Form.Group className="mb-3">
                                    <Form.Control
                                        type="email"
                                        placeholder="Email"
                                        value={formData.email}
                                        onChange={e => setFormData(prev => ({ ...prev, email: e.target.value }))}
                                        required
                                    />
                                </Form.Group>
                                <label className='mb-2 login_label'>Enter Password</label>
                                <Form.Group className="mb-3">
                                    <Form.Control
                                        type="password"
                                        placeholder="Password"
                                        value={formData.password}
                                        onChange={e => setFormData(prev => ({ ...prev, password: e.target.value }))}
                                        required
                                    />
                                </Form.Group>
                                <Button variant="danger" type="submit" className="w-100">
                                    Login
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
        </div>
        {/* <Container className="mt-5">
        </Container> */}
        </>
    );
};

export default LoginForm